import {
  LuBellOff,
  LuCalendarDays,
  LuCloudRain,
  LuConstruction,
  LuDroplets,
  LuHeartPulse,
  LuReceipt,
  LuRecycle,
  LuSnowflake,
  LuTriangleAlert,
  LuZap,
} from 'react-icons/lu';
import { IconType } from 'react-icons';
import { ComuniTopic } from './constants';

export const COMUNI_TABS_ITEM = {
  NEW_COMMUNICATION: 'newCommunication',
  UPLOADED_LISTS: 'uploadedLists',
  TEMPLATES: 'templates',
  INBOX: 'inbox',
  CITIZEN_FORMS: 'citizenForms',
} as const;

export type ComuniTabsItem = (typeof COMUNI_TABS_ITEM)[keyof typeof COMUNI_TABS_ITEM];

export const COMUNI_NEW_COMMUNICATION_STEPS_ITEM = {
  RECIPIENTS: 'recipients',
  TOPIC: 'topic',
  CHANNELS: 'channels',
  TEMPLATE: 'template',
  PREVIEW: 'preview',
} as const;

export type ComuniNewCommunicationStepsItem = (typeof COMUNI_NEW_COMMUNICATION_STEPS_ITEM)[keyof typeof COMUNI_NEW_COMMUNICATION_STEPS_ITEM];

export const COMUNI_NEW_COMMUNICATION_STEPS = [
  { id: COMUNI_NEW_COMMUNICATION_STEPS_ITEM.RECIPIENTS, title: 'comuni.steps.recipients' },
  { id: COMUNI_NEW_COMMUNICATION_STEPS_ITEM.TOPIC, title: 'comuni.steps.topic' },
  { id: COMUNI_NEW_COMMUNICATION_STEPS_ITEM.CHANNELS, title: 'comuni.steps.channels' },
  { id: COMUNI_NEW_COMMUNICATION_STEPS_ITEM.TEMPLATE, title: 'comuni.steps.template' },
  { id: COMUNI_NEW_COMMUNICATION_STEPS_ITEM.PREVIEW, title: 'comuni.steps.preview' },
] as const;

export type ComuniNewCommunicationSteps = (typeof COMUNI_NEW_COMMUNICATION_STEPS)[number];

export const NO_TOPIC = 'none' as const;
export type TopicChoice = ComuniTopic | typeof NO_TOPIC;

export const TOPIC_ICONS: Record<TopicChoice, IconType> = {
  none: LuBellOff,
  strade: LuConstruction,
  meteo: LuCloudRain,
  sisma: LuTriangleAlert,
  idrico: LuDroplets,
  elettrico: LuZap,
  eventi: LuCalendarDays,
  rifiuti: LuRecycle,
  tributi: LuReceipt,
  sanita: LuHeartPulse,
  neve: LuSnowflake,
};
